export * from './static-file.pipe';
export * from './truncate-text.pipe';
